import { Card } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useResponsiveQuery } from 'utils/responsiveQuery/useResponsiveQuery';
import { selectUsedTaskResourcesArrLength } from '../../slice/selectors';
import TaskPlannedResourcesTable from '../TaskPlannedResourcesTable/TaskPlannedResourcesTable';
import TaskThisStageUsedResourcesTable from '../TaskThisStageUsedResourcesTable/TaskThisStageUsedResourcesTable';
import TaskUsedResourcesTable from '../TaskUsedResourcesTable/TaskUsedResourcesTable';

interface IProps {}

const TaskProgressResourcesCard: FC<IProps> = () => {
  const { t } = useTranslation();
  const { mobileOrTablet } = useResponsiveQuery();

  const usedResourcesArrLength = useSelector(selectUsedTaskResourcesArrLength);

  return (
    <>
      <Card
        bordered={false}
        title={t(
          'Task.ResourcesCard.PlannedTaskResources',
          'Planned task resources',
        )}
      >
        <TaskPlannedResourcesTable loading={false} />
      </Card>

      <Card
        bordered={false}
        title={t(
          'Task.ResourcesCard.UsedResourcesAtThisStage',
          'Used resources at this stage',
        )}
        style={{ marginTop: 12 }}
      >
        <TaskThisStageUsedResourcesTable />
      </Card>
      {Boolean(usedResourcesArrLength) && (
        <Card
          bordered={false}
          title={t('Task.ResourcesCard.UsedResources', 'Used resources')}
          style={{
            marginTop: 12,
            overflow: 'auto',
            maxWidth: '100%',
          }}
          bodyStyle={{
            paddingLeft: mobileOrTablet ? 6 : undefined,
            paddingRight: mobileOrTablet ? 6 : undefined,
            overflow: 'auto',
          }}
        >
          <TaskUsedResourcesTable />
        </Card>
      )}
    </>
  );
};

export default TaskProgressResourcesCard;
